const usePasswordRules = (value = '') => {
    const result = {};
    result.length = value.trim().length >= 8;
    result.digit = /[0-9]/g.test(value);
    // eslint-disable-next-line no-useless-escape
    result.special = /[!"#$%&'()*+,\-.\/:\\;<=>?@\[\]^_`{|}]/gi.test(value);
    result.case = /[A-Z]/g.test(value);

    return result;
};

export default usePasswordRules;
